export default {
    'playtech.mobile.system.limitEdit.current.day': 'Daily limit: {0}',
    'playtech.mobile.system.limitEdit.current.week': 'Weekly limit: {0}',
    'playtech.mobile.system.limitEdit.current.month': 'Monthly limit: {0}',
    'playtech.mobile.system.limitEdit.resetDate': 'till {0}',
    'playtech.mobile.system.limitEdit.newLimitMessage': 'New limit <b>({0})</b> starts<br /> from {1}',
    'playtech.mobile.system.limitEdit.setNewLimit': 'Set new limit',
    'playtech.mobile.system.limitEdit.makeLimited': 'Make limited',
    'playtech.mobile.system.limitEdit.makeUnlimited': 'Make unlimited',
    'playtech.mobile.system.limitEdit.unlimited': 'Unlimited',
    'playtech.mobile.system.limitEdit.unset': 'not set'
};
